// @flow
import * as React from 'react';
import { TermsAndConditionsWithModalField, FocusOfContentSelectField } from 'app/default/field';
import Buttons from 'app/default/button';
import { Recaptcha, Hcaptcha } from 'app/generic/field';

type CompanyComponentProps = {
    networkId: string,
    captchaProvider?: string
};

const CompanyComponent = ({ networkId, captchaProvider }: CompanyComponentProps) => (
    <form>
        <FocusOfContentSelectField />

        <TermsAndConditionsWithModalField networkId={networkId} />
        
        <Buttons back submit />

        {captchaProvider !== ''
            ? captchaProvider !== 'recaptcha'
                ? (
                    <Hcaptcha />
                ) : (
                    <Recaptcha />
                ) 
            : null}
    </form>
);

export default CompanyComponent;
